<template>
	<div>
		<AppButton
			v-if="authStore.hasWhatsappMarketplace"
			:label="$t('orders.create-order')"
			startIcon="assets/v2/image/icons/plus.svg"
			@click="onCreateOrder"
			:loading="loading"
		/>
	</div>
</template>

<script setup>
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { ref } from 'vue';
import { abilities, useLimitationsStore } from '@/v2/modules/products/stores/limitations';

const authStore = useAuthStore();
const loading = ref(false);
const limitationStore = useLimitationsStore();

const onCreateOrder = async () => {
	loading.value = true;
	limitationStore
		.checkLimitation(abilities.CreateOrder)
		.then(() => {
			window.open(`/orders/create`, '_blank');
		})
		.finally(() => {
			loading.value = false;
		});
};
</script>

<style lang="scss" scoped></style>
